'use client';

import { Checkbox, Hint, Label } from 'components';
import { decamelize } from 'humps';
import { useTranslations } from 'next-intl';
import { useClientAccountUpdate } from 'providers/UserProvider/useClientAccountUpdate';
import { useCurrentUser } from 'providers/UserProvider/useCurrentUser';
import { useEffect, useState } from 'react';

const NOTIFICATION_TYPES = ['dailyClientNotification', 'translatorComments'] as const;

const EmailSubscriptionsPage = () => {
  const t = useTranslations();
  const { data, refetch } = useCurrentUser();

  const initialState = {
    dailyClientNotification: false,
    reviewStyleGuide: false,
    translatorComments: false
  };
  const [state, setState] = useState(initialState);
  const { mutateAsync } = useClientAccountUpdate();

  const handlerUpdateSubscription = (notificationType: keyof typeof initialState) => () =>
    setState((oldState) => {
      const notificationResult = { ...oldState, [notificationType]: !oldState[notificationType] };
      mutateAsync({
        firstName: String(data?.firstName),
        lastName: String(data?.lastName),
        locale: String(data?.locale),
        timeZone: String(data?.timeZone),
        emailNotifications: notificationResult
      }).then(() => refetch());
      return notificationResult;
    });

  useEffect(() => {
    if (data?.emailPreferences) setState(data.emailPreferences);
  }, [data?.emailPreferences]);

  return (
    <div>
      <Label>{t('email_subscription.email_notifications')}</Label>
      {NOTIFICATION_TYPES.map((notificationType) => {
        const id = `subscribe-to-${notificationType}`,
          decamelizedNotificationType = decamelize(notificationType);

        return (
          <div key={id} className="mb-2">
            <Checkbox
              checked={!!state[notificationType]}
              onChange={handlerUpdateSubscription(notificationType)}
              name={id}
              label={t(`email_subscription.${decamelizedNotificationType}` as any)}
            />
            <Hint className="ml-6">
              {t(`email_subscription.${decamelizedNotificationType}_details` as any)}
            </Hint>
          </div>
        );
      })}
    </div>
  );
};

export default EmailSubscriptionsPage;
